import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ChatService as CloudChatService, Config } from '@mitel/cloudlink-sdk';
import { AdminService } from './admin.service';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })

export class ChatService {
    private readonly api: CloudChatService;
    public readonly cloud: string;

    constructor() {
        this.cloud = Config.cloud = environment.cloud;
        this.api = new CloudChatService();
    }

    get url(): string {
        return `https://chat${Config.cloud === 'dev' ? '.dev' : ''
            }.api.mitel.io/2017-09-01`;
    }

    getCommand(commandId: string) {
        return this.api.getCommand({ commandId })
    }

    deleteCommand(commandId: string) {
        return this.api.deleteCommand({ commandId });
    }

    createCommand(body: any) {
        return this.api.createCommand({ body })
    }
}
